(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ell-cart-smart-add-on"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ell-cart-add-on')) {
    customElements.define('ell-cart-add-on', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-ell-addon-add]');
          if (button && this.contains(button)) this.addToCart(event, button);
        });
      }

      connectedCallback() {
        const button = this.querySelector('[data-ell-addon-add]');
        if (!button) return;
        customElements.whenDefined('cart-drawer').then(() => {
          const drawer = this.closest('cart-drawer');
          if (!this.isConnected || typeof drawer?.renderContents !== 'function') return;
          button.hidden = false;
          button.disabled = drawer.dataset.ellAddonBusy === 'true' || drawer.dataset.ellAddonNeedsRefresh === 'true';
          this.querySelector('[data-ell-addon-link]').hidden = true;
        });
      }

      async addToCart(event, button) {
        event.preventDefault();
        const drawer = this.closest('cart-drawer');
        const variantId = button.dataset.variantId;
        if (!drawer || this.pending || button.disabled || drawer.dataset.ellAddonBusy === 'true' || drawer.dataset.ellAddonNeedsRefresh === 'true') return;
        if (!/^\d+$/.test(variantId)) return;

        const buttonText = button.textContent;
        const sections = drawer.getSectionsToRender();
        this.pending = true;
        drawer.dataset.ellAddonBusy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.loading;
        this.querySelector('[data-ell-addon-message]').hidden = true;
        this.querySelector('[data-ell-addon-recovery]').hidden = true;

        let added = false;
        let refreshed = false;
        let deferred;
        try {
          deferred = this.createUpdateEvent(variantId);
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          formData.append('sections', sections.map((section) => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const state = await response.json();
          if (!response.ok || state.status) {
            const error = new Error(typeof state.description === 'string' ? state.description : this.dataset.error);
            error.cartRejected = true;
            throw error;
          }

          added = true;
          this.resolveUpdateEvent(deferred);
          if (!this.hasSections(state.sections, sections)) {
            const url = new URL(window.location.pathname, window.location.origin);
            url.searchParams.set('sections', sections.map((section) => section.id).join(','));
            const sectionResponse = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!sectionResponse.ok) throw new Error(this.dataset.error);
            state.sections = await sectionResponse.json();
          }
          if (!this.hasSections(state.sections, sections)) throw new Error(this.dataset.error);

          drawer.renderContents(state);
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ell-cart-add-on',
            productVariantId: variantId,
            cartData: state,
          });
          refreshed = true;
          const liveRegion = drawer.querySelector('#CartDrawer-LiveRegionText');
          if (liveRegion) {
            liveRegion.setAttribute('aria-hidden', 'false');
            liveRegion.textContent = this.dataset.added;
          }
        } catch (error) {
          if (!added) deferred?.reject(error);
          const message = added ? this.dataset.added : error.cartRejected ? error.message : this.dataset.error;
          this.showFeedback(drawer, message, added);
          const errorMessage = error.cartRejected ? error.message : this.dataset.error;
          const { CartErrorEvent } = window.StandardEvents || {};
          if (CartErrorEvent) {
            drawer.dispatchEvent(new CartErrorEvent({
              error: errorMessage,
              code: error.cartRejected ? 'INVALID' : 'SERVICE_UNAVAILABLE',
            }));
          }
          Promise.resolve().then(() => publish(PUB_SUB_EVENTS.cartError, {
            source: 'ell-cart-add-on', productVariantId: variantId, errors: errorMessage, message: errorMessage,
          })).catch(() => {});
        } finally {
          this.pending = false;
          delete drawer.dataset.ellAddonBusy;
          if (added && !refreshed) drawer.dataset.ellAddonNeedsRefresh = 'true';
          button.removeAttribute('aria-busy');
          button.textContent = buttonText;
          button.disabled = added && !refreshed;
          drawer.querySelectorAll('[data-ell-addon-add]').forEach((currentButton) => {
            currentButton.disabled = added && !refreshed;
          });
          if (added) this.restoreFocus(drawer, variantId);
        }
      }

      hasSections(rendered, sections) {
        return sections.every((section) => typeof rendered?.[section.id] === 'string' && rendered[section.id].trim());
      }

      restoreFocus(drawer, variantId) {
        if (!drawer.classList.contains('active')) return;
        const inner = drawer.querySelector('.drawer__inner');
        const item = drawer.querySelector(`[data-quantity-variant-id="${variantId}"]`)?.closest('.cart-item');
        const focusTarget = item?.querySelector('.cart-item__name') || inner;
        if (inner && focusTarget) trapFocus(inner, focusTarget);
      }

      showFeedback(drawer, message, added) {
        const current = this.isConnected ? this : drawer.querySelector('ell-cart-add-on');
        const region = current?.querySelector('[data-ell-addon-message]') || drawer.querySelector('#CartDrawer-CartErrors');
        if (!region) return;
        region.hidden = false;
        region.textContent = message;
        if (added) {
          const link = current?.querySelector('[data-ell-addon-recovery]');
          if (link) {
            link.hidden = false;
          } else {
            const recovery = document.createElement('a');
            recovery.href = this.dataset.cartUrl;
            recovery.className = 'ell-cart-addon__link';
            recovery.textContent = this.dataset.viewCart;
            region.append(' ', recovery);
          }
        }
      }

      createUpdateEvent(variantId) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;
        const deferred = CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add', context: 'cart',
          lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise,
        }));
        return deferred;
      }

      resolveUpdateEvent(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        const cartPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${window.routes.cart_url}.json`).then((response) => response.json());
        cartPromise.then((cart) => {
          if (!cart?.currency) throw new Error(this.dataset.error);
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
        }).catch((error) => deferred.reject(error));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
